export default 'blueHeader/modalWindow'
